<template>
  <div class="px-3 pt-3 sm:px-8 sm:pt-8">
    <div
      class="sm:my-6 p-4 sm:p-6 rounded mx-auto max-w-2xl"
      :style="config.form.styles">

      <div
        class="ql-container"
        v-html="config.form.content" />

      <div
        v-if="errorMessage"
        class="mt-3 mx-auto"
        :style="config.form.formFields.styles">
        <XMessageBox
          type="error"
          :message="errorMessage"
          :customStyles="config.form.formFields.errors.styles" />
      </div>

      <div
        class="flex items-center justify-center mx-auto"
        :style="config.form.formFields.styles">
        <XButton
          class="mt-3 mr-2"
          :size="config.form.formFields.confirm.size"
          :style="config.form.formFields.confirm.styles"
          :loading="loading"
          @click="onConfirm">
          {{ config.form.formFields.confirm.content }}
        </XButton>

        <XButton
          class="mt-3 ml-2"
          :size="config.form.formFields.decline.size"
          :style="config.form.formFields.decline.styles"
          :loading="loading"
          @click="onDecline">
          {{ config.form.formFields.decline.content }}
        </XButton>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { sendHitTrack } from '@plat/util/analytics'
import FormBaseValidator from '@common/mixins/FormBaseValidator'

export default {

  mixins: [FormBaseValidator],

  provide () {
    return {
      '$validator': this.$validator
    }
  },

  components: {},

  props: {
    config: {
      type: Object,
      required: true
    },
    lang: {
      type: Object,
      required: false
    },
    eventId: {
      type: String,
      required: true
    },
    eventSlug: {
      type: String,
      required: true
    },
    attendee: {
      type: Object
    }
  },

  data () {
    return {
      fields: {
        customFields: {}
      },
      loading: false,
      typeTextList: [
        'firstName',
        'lastName',
        'secondLastName',
        'phone',
        'postalCode'
      ],
      errorMessage: null,
      locale: {
        es: 'Español',
        en: 'Ingles'
      }
    }
  },

  created () {
  },

  watch: {
    '$i18n.locale': function (locale) {
      let vLocale = locale.split('_').shift()

      import('vee-validate/dist/locale/' + vLocale
        /* webpackChunkName: "validation-locales" */
        /* webpackInclude: /en\.js es\.js/ */
        /* webpackMode: "lazy" */)
        .then(localeModule => {
          this.$validator.localize(vLocale, localeModule)
        })
    }
  },

  computed: {},

  mounted () {
    const locale = this.$i18n.locale.split('_').shift()
    this.$validator.localize(locale)
  },

  methods: {
    onConfirm () {
      if (this.loading) {
        return
      }

      this.loading = true
      this.errorMessage = null

      return this.confirmCancelConfirmation()
        .then(() => {
          try {
            sendHitTrack({ category: 'attendee', event: 'cancel-confirmation-confirmed' })
          } catch (errors) {}

          this.$router.replace('success')
        })
        .catch(errors => {
          let graphQLError = errors.graphQLErrors ? errors.graphQLErrors[0] : null

          this.errorMessage = graphQLError && this.getGraphQlValidationError(graphQLError)
            ? this.getGraphQlValidationError(graphQLError)
            : this.$t('common.notifications.messages.requestError')

          this.loading = false
        })
    },

    onDecline () {
      this.loading = true
      this.errorMessage = null

      try {
        sendHitTrack({ category: 'attendee', event: 'cancel-confirmation-declined' })
      } catch (errors) {}

      this.$router.replace('decline')
    },

    confirmCancelConfirmation () {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation confirmCancelConfirmation($attendeeId: Uuid!) {
              attendee(attendeeId: $attendeeId) {
                confirmCancelConfirmation
              }
            }
          `,
          variables: {
            attendeeId: this.attendee.id
          }
        })
        .then(result => {
          if (!result.data.attendee.confirmCancelConfirmation) {
            throw new Error()
          }
        })
    },

    getGraphQlValidationError (graphQLError) {
      if (graphQLError.extensions.category === 'validationNotPassed') {
        let validationKeys = Object.keys(graphQLError.validation)
        let validationMessage = graphQLError.validation[validationKeys[0]][0]

        return graphQLError.message + ': ' + validationMessage
      }

      return null
    }
  }
}
</script>

<style lang="scss" module>
.terms {
  p {
    line-height: 1;
  }
}
</style>
